/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Gotcertificate1Inputs */

const en__field_gotcertificate1 = /** @type {(inputs: _Field_Gotcertificate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certificate received`)
};

const de__field_gotcertificate1 = /** @type {(inputs: _Field_Gotcertificate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zertifikat erhalten`)
};

/**
* | output |
* | --- |
* | "Certificate received" |
*
* @param {_Field_Gotcertificate1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_gotcertificate1 = /** @type {((inputs?: _Field_Gotcertificate1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Gotcertificate1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_gotcertificate1(inputs)
	return de__field_gotcertificate1(inputs)
});
export { _field_gotcertificate1 as "_field_gotCertificate" }